import React, { Component } from "react";
import p5 from "p5";
import SpaceMono from "../assets/fonts/SpaceMono-Regular.ttf";


export default class App extends Component {
    //React ref for div reference we pass into p5
    sketchRef = React.createRef();


    //P5 instance mode
    initSketch = (p) => {
        let canvas;
        // let pg1;
        // let p1;

        let w = window.innerWidth;
        let h = window.innerHeight;

        let rw = w * 0.65;

        let basic = "I was told"

        let data = [
            "'he",
            "is",
            "on",
            "the",
            "rooftops'"
        ];

        let degree = [
            "30",
            "-30",
            "20",
            "-20",
            "10"
        ]
        let font;

        p.preload = () => {
            font = p.loadFont(SpaceMono, font);
        };

        p.setup = () => {
            //store width and height
            //setup canvas and init values here
            canvas = p.createCanvas(rw, h);

            //normal canvas
            

        };

        p.draw = () => {

            p.background('#F4F4F5');
            // p.textAlign(p.CENTER. p.CENTER);
            // p.fill('#ffffff');
           

            
            // p.textSize(fontSize);

            let stepX = rw / data.length;
            let wave2 = p.map(p.tan(p.radians(p.frameCount)), -1, 1, -100, 100);

            for (let i = 0; i < data.length; i++) {

                let wave = p.map(p.tan(p.radians(p.frameCount + i * 5)), -1, 1, -100, 100);
                
                p.translate(0, 0);
                p.textFont(font);
                p.push();
                p.translate(rw / 2, h / 12);
                p.textAlign(p.CENTER, p.CENTER);
                p.fill('#7C503C');
                p.textSize(50);
                p.text(basic.toUpperCase(), 0, 0);
                p.pop();

                p.push();
                p.translate(i * stepX + wave, p.height / 2);

                p.rotate(p.radians(degree[i])* p.frameCount * 0.01);
                p.fill('#7C503C');
                p.textSize(60);
                p.text(data[i].toUpperCase(), 0, 0);
                p.pop();

                p.push();
                p.translate(rw /2, h/2);
                p.blendMode(p.MULTIPLY);
                // p.fill('#83A9F4');
                p.ellipse(0 + wave, 0, p.mouseX + i * 100 + wave, p.mouseX + i * 100);
                p.pop();

            }
            

            //show the results
           
        };

        p.windowResized = () => {
            w = window.innerWidth;
            h = window.innerHeight;
            rw = w * 0.65;
            p.resizeCanvas(rw, h);
        };

    };

    componentDidMount() {
        //Create p5 canvas once component mounts
        this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
    }

    componentWillUnmount() {
        this.p5Canvas.remove();
        window.removeEventListener('resize', this.windowResized);
    }

    render() {
        //this div will contain the sketch canvas
        return <div className="mySketch" ref={this.sketchRef} />;
    }
}

